export class ReminderConstants {
  static ReminderTypeDaily = "daily";
  static ReminderTypeWeekly = "weekly";
  static ReminderTypeMonthly = "monthly";
}
